/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyMigrationDecision {
    KEEP = 'keep',
    IGNORE = 'ignore',
}
